import { SVGProps } from 'react';
const IcList = (props: SVGProps<SVGSVGElement>) => (

  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <g clipPath='url(#clip0_25263_276114)'>
      <path
        d='M3.53887 16.2983C3.19168 16.2986 2.85236 16.4018 2.56381 16.5949C2.27527 16.7879 2.05047 17.0623 1.91783 17.3831C1.78518 17.704 1.75067 18.0569 1.81864 18.3974C1.88661 18.7379 2.05401 19.0506 2.29968 19.2959C2.54535 19.5412 2.85825 19.7082 3.19882 19.7757C3.53938 19.8432 3.89231 19.8082 4.21298 19.6751C4.53365 19.542 4.80765 19.3168 5.00034 19.028C5.１９３０３ １８．７３９２ ５．２９５７４ １８．３９９７ ５．２９５５ １８．０５２５C５．２９４５３ １７．５８７２ ５．１０９０７ １７．１４１２ ４．７７９７８ １６．８１２３C４．４５０４８ １６．４８３５ ４．００４２３ １６．２９８７ ３．５３８８７ １６．２９８３Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        d='M3.53914 9.74792C3.1334 9.74843 2.74038 9.88956 2.42701 10.1473C2.11365 10.405 1.89931 10.7634 1.82051 11.1614C1.74171 11.5595 1.80332 11.9725 1.99485 12.3302C2.18638 12.6879 2.49597 12.9681 2.87092 13.1232C3.24586 13.2782 3.66296 13.2985 4.05119 13.1806C4.43941 13.0626 4.77475 12.8138 5.00009 12.4764C5.22543 12.139 5.32684 11.7339 5.28705 11.3301C5.24726 10.9263 5.06872 10.5488 4.78185 10.2619C4.45211 9.9326 4.00512 9.74775 3.53914 9.74792Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        d='M3.5388 3.19751C3.07308 3.19751 2.62642 3.38252 2.2971 3.71184C1.96779 4.04116 1.78278 4.48781 1.78278 4.95354C1.78278 5.41926 1.96779 5.86592 2.2971 6.19524C2.62642 6.52456 3.07308 6.70956 3.5388 6.70956C4.00453 6.70956 4.45118 6.52456 4.7805 6.19524C5.10982 5.86592 5.29483 5.41926 5.29483 4.95354C5.29483 4.48781 5.10982 4.04116 4.7805 3.71184C4.45118 3.38252 4.00453 3.19751 3.5388 3.19751Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        d='M21.0051 3.74634H7.90787C7.23839 3.74634 6.69568 4.28878 6.69568 4.95792C6.69568 5.62705 7.23839 6.1695 7.90787 6.1695H21.0051C21.6746 6.1695 22.2173 5.62705 22.2173 4.95792C22.2173 4.28878 21.6746 3.74634 21.0051 3.74634Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        d='M21.0051 10.2917H7.90787C7.23839 10.2917 6.69568 10.8342 6.69568 11.5033C6.69568 12.1725 7.23839 12.7149 7.90787 12.7149H21.0051C21.6746 12.7149 22.2173 12.1725 22.2173 11.5033C22.2173 10.8342 21.6746 10.2917 21.0051 10.2917Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        d='M21.0064 16.8473H7.90665C7.23785 16.8473 6.69568 17.3895 6.69568 18.0583C6.69568 18.7271 7.23785 19.2692 7.90665 19.2692H21.0064C21.6752 19.2692 22.2173 18.7271 22.2173 18.0583C22.2173 17.3895 21.6752 16.8473 21.0064 16.8473Z'
        fill={props.fill || '#232F3E'}
      />
    </g>
    <defs>
      <clipPath id='clip0_25263_276114'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export default IcList;
